import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CloudText,
  CloudTitle,
  LinkButton,
  LinksWrapper,
} from './index.styles';

export default function BasicInfoContent() {
  const { t } = useTranslation();
  return (
    <>
      <CloudTitle>{t('basicInfoCloud.title')}</CloudTitle>
      <CloudText
        dangerouslySetInnerHTML={{ __html: t('basicInfoCloud.desc') }}
      />
      <LinkButton
        href="mailto:contact@envirly.com"
        target="_blank"
        rel="noreferrer"
      >
        contact@envirly.com
      </LinkButton>
      <LinksWrapper>
        <a href="tel:+48698759206" target="_blank" rel="noreferrer">
          +48 698 759 206
        </a>
        <a href="mailto:contact@envirly.com" target="_blank" rel="noreferrer">
          contact@envirly.com
        </a>
      </LinksWrapper>
    </>
  );
}
